import { UPDATE_INFO_ORDER } from './type';

// CART
export const updateInfoOrderStore = (payload) => {
    return {
        type: UPDATE_INFO_ORDER,
        payload,
    };
};
